export default __webpack_public_path__ + "static/media/arrow_out.eb7d8b0d.svg";